<template>
  <div class="col95 glassModulo" style="background:white;color:black;min-height: 70vh;">
    
    <div class="block tCenter" style="width:100%;">
      
      <div class="fullWidth tCenter " style="margin:0 auto;min-height: 20px;">
        
        <h2 class="fullWidth row colSm90 center subtitleSize" style="font-family: town;color:var(--orange);vertical-align: top;"  v-if="userStore.carritoCursos.length==0">
          <strong style="text-shadow: 4px 4x 14px rgba(31,38,135,0.8);">
            REGISTRO DE ANTECEDENTES MÉDICOS DEL ALUMNO
          </strong>
        </h2>
        <button class="btnDefault left" v-on:click="sendClose()" style="vertical-align: top;">
          <i class="bi bi-arrow-left"></i>
          <small class="hideMobile">
            Regresar
          </small>
        </button>

      </div>

      <div class="formRow col90 center" style="margin-top:10px;">

            <!--
              Nuevo Alumno
            -->
        
        


          <div class="formRow col95 tLeft" style="overflow-y:auto;overflow-x:hidden;max-height:75vh;">
        
            <!--
            <div class="col98 colSm95 center tLeft" style="background:none;">
              <div class="col93 colSm95 center" >
                  <strong class="formLabel">        
                    Plantel:
                  </strong>
                  <span style="min-width:5%;width:5%;"></span>
                  
                  <input-select ref="plantelRef" :optionName="'Plantel'"  :whiteBackground="false" 
                  :optionsArray="listaPlanteles" :propName="'plantel'"
                  ></input-select>
                                      
              </div>
            </div>
            -->

            <section style="display:flex;">
              <button :class="(modo=='ENFERMEDAD'?'btnBlue ':'btnDefault ')+'col20 row fieldSize'" @click="modo='ENFERMEDAD'" style="line-height:3dvh;">
                Enfermedad Crónica
              </button>
              <button :class="(modo=='ALERGIAS'?'btnBlue ':'btnDefault ')+'col20 row fieldSize'" @click="modo='ALERGIAS'" style="line-height:3dvh;">
                Alergias
              </button>
              <button :class="(modo=='MEDICAMENTOS'?'btnBlue ':'btnDefault ')+'col20 row fieldSize'" @click="modo='MEDICAMENTOS'" style="line-height:3dvh;">
                Medicamentos
              </button>
              <button :class="(modo=='DISCAPACIDAD'?'btnBlue ':'btnDefault ')+'col20 row fieldSize'" @click="modo='DISCAPACIDAD'" style="line-height:3dvh;">
                Discapacidad
              </button>
              <button :class="(modo=='ANTECEDENTES'?'btnBlue ':'btnDefault ')+ 'col20 row fieldSize'" @click="modo='ANTECEDENTES'" style="line-height:3dvh;">
                Antecedentes Quirurgicos
              </button>
            </section>


            <section class="fullWidth center tCenter" style="margin-top:5px;">

              <div class="hideMobile" style="min-height:5vh;">
                <span></span>
              </div>

              <div class="fullWidth" v-if="modo=='ENFERMEDAD'">
                      
                  <strong class="formLabel ">
                    Enfermedad Crónica:
                  </strong>              

                  <div class="tLeft fullWidth">
                    <div>
                      <div class="col50 row colSmMin95">
                        ¿Padece de alguna enfermedad crónica?
                      </div>

                      <div class="col50 row colSmMin100">
                        <button :class="'col50 row '+(showNuevaEnfermedad?'btnBlue':'btnDefault')" @click="showNuevaEnfermedad=true;">
                          Si
                        </button>  
                        <button :class="'col50 row '+(!showNuevaEnfermedad?'btnBlue':'btnDefault')" @click="showNuevaEnfermedad=false;sendUpdateEstadoEnfermedad('1');">
                          No
                        </button>
                      </div>

                    </div>
                    
                    <div v-if="showNuevaEnfermedad">

                      <!--
                      :key="formData.enfermedad.key+listaCatalogoEnfermedades.lenght" 
                      -->

                      <input-select-list
                      class="col75 row" 
                      :allowNew="true" 
                      :maxLength="85"
                      :minLength="4"
                      :capital="true"
                      :mode="'AN'"
                      :optionName="'tipo de enfermedad'"
                      :optionsArray="listaCatalogoEnfermedades"
                      :displayFieldname="'c0'"
                      :valFieldName="'c0'"
                      :ref="'enfermedadRef'"
                      :placeholder="'Nombre de la enfermedad crónica'" 
                      :propName="'enfermedad'"
                      :whiteBackground="false"
                      :key="formData.enfermedad.data"
                      v-if="showNuevaEnfermedad"
                      ></input-select-list>
                      <button class="btnBlue col25 row" @click="addNewEnfermedadCronica" v-if="formData.enfermedad.data!=''">
                        <i class="bi bi-plus col15 row left" style="font-size: 1.5rem;"></i>
                        <small class="col80 row">
                          Agregar
                        </small>
                      </button>

                    </div>
                    <div>
                      <strong>
                        Enfermedades Crónicas (Total: {{listaEnfermedades.length}}):
                      </strong>

                      <div class="col95" style="max-height: 20vh;min-height:20vh;overflow-y:auto;"  v-if="listaEnfermedades.length>0">
                        <div v-for="(enfermedad,eI) in listaEnfermedades" :key="enfermedad" style="margin-left:20px;">
                          <button class="btnDefault" @click="deleteEnfermedadCronica(''+enfermedad.c1)">
                            <i class="bi  bi-x" style="font-size: 1rem;"></i>
                          </button>
                          {{eI+1}} | {{enfermedad.c0}}
                        </div>
                      </div>

                      <div class="col95" style="max-height: 20vh;min-height:20vh;overflow-y:auto;" v-else>
                        <div style="margin-left:20px;margin-top:20px;">
                          <!--
                            <button class="btnDefault">
                              <i class="bi  bi-x" style="font-size: 1rem;"></i>
                            </button>
                          -->
                          No hay enfermedades registradas
                        </div>
                      </div>
                      
                      

                    </div>
                    <!--
                      <div v-else style="min-height:20vh;">
                        <span>                        
                        </span>
                      </div>
                    -->
                  </div>
                  <!--
                    <div style="margin-top:30px;">
                      <button class="btnBlue fullWidth center">
                        <i class="bi bi-pencil-square"></i>
                        Registrar Información de Enfermedades
                      </button>
                    </div>
                  -->
                        
                
              </div>

              <div class="fullWidth" v-if="modo=='ALERGIAS'">
              
                    
                  <strong class="formLabel " >        
                    Alergia:
                  </strong>                  

                  <div class="tLeft fullWidth">
                    <div>
                      <div class="col50 row colSmMin95">
                        ¿Padece de alguna alergia?
                      </div>

                      <div class="col50 row colSmMin100">
                        <button class="btnDefault col50 row" @click="showNuevaAlergia=true;">
                          Si
                        </button>
                        <button class="btnDefault col50 row" @click="showNuevaAlergia=false;">
                          No
                        </button>
                      </div>

                    </div>
                    
                    <div v-if="showNuevaAlergia">
                      <input-select-list
                      class="col75 row" 
                      :allowNew="true" 
                      :maxLength="85"
                      :minLength="4"
                      :capital="true"
                      :mode="'AN'"
                      :optionName="'Tipo de Alergia'"
                      :optionsArray="listaCatalogoAlergias"
                      :displayFieldname="'c0'"
                      :valFieldName="'c0'"
                      :ref="'alergiaRef'"
                      :placeholder="'Nombre de la alergia'" 
                      :propName="'alergia'"
                      :whiteBackground="false" 
                      ></input-select-list>
                      <button class="btnBlue col25 row" @click="addNewAlergia" v-if="formData.alergia.data!=''">
                        <i class="bi bi-plus col15 row left" style="font-size: 1.5rem;"></i>
                        <small class="col80 row">
                          Agregar
                        </small>
                      </button>

                    </div>
                    <div v-if="listaAlergias.length>0">
                      <strong>
                        Alergias (Total: {{listaAlergias.length}}):
                      </strong>
                      <div class="col95" style="max-height: 20vh;min-height:20vh;overflow-y:auto;">
                        <div v-for="(alergia,aI) in listaAlergias" :key="alergia" style="margin-left:20px;">
                          <button class="btnDefault" @click="deleteAlergia(''+alergia.c1)">
                            <i class="bi  bi-x" style="font-size: 1rem;"></i>
                          </button>
                          {{aI+1}} | {{alergia.c0}}
                        </div>
                      </div>
                    </div>
                    <div v-else  style="min-height:20vh;">
                      <span>                        
                      </span>
                    </div>
                    <!--
                      <div style="margin-top:30px;">
                        <button class="btnBlue fullWidth center">
                          <i class="bi bi-pencil-square"></i>
                          Registrar Información de Alergias
                        </button>
                      </div>
                      -->

                  </div>
                  
              </div>

              <div class="fullWidth" v-if="modo=='MEDICAMENTOS'">
    
                  <strong class="formLabel " >        
                    Medicamentos:
                  </strong>
                  

                  <div class="tLeft fullWidth">
                    <div>
                      <div class="col50 row colSmMin95">
                        ¿Utiliza algún medicamento?
                      </div>
                      <div class="col50 row colSmMin100">
                        <button :class="(showNuevoMedicamento?'btnBlue':'btnDefault')+' col50 row'" @click="showNuevoMedicamento=true;">
                          Si
                        </button>
                        <button :class="(!showNuevoMedicamento?'btnBlue':'btnDefault')+' col50 row'" @click="showNuevoMedicamento=false;">
                          No
                        </button>
                      </div>
                    </div>
                    
                    <div v-if="showNuevoMedicamento">
                      <input-select-list
                      class="col75 row" 
                      :allowNew="true" 
                      :maxLength="85"
                      :minLength="4"
                      :capital="true"
                      :mode="'AN'"
                      :optionName="'Nombre del Medicamento'"
                      :optionsArray="listaCatalogoMedicamentos"
                      :displayFieldname="'c0'"
                      :valFieldName="'c0'"
                      :ref="'medicamentoRef'"
                      :placeholder="'Nombre del medicamento'" 
                      :propName="'medicamento'"
                      :whiteBackground="false" 
                      ></input-select-list>
                      <button class="btnBlue col25 row" @click="addNewMedicamento" v-if="formData.medicamento.data!=''">
                        <i class="bi bi-plus col15 row left" style="font-size: 1.5rem;"></i>
                        <small class="col80 row">
                          Agregar
                        </small>
                      </button>
                      

                    </div>
                    <div v-if="listaMedicamentos.length>0">
                      <strong>
                        Medicamentos (Total: {{listaMedicamentos.length}}):
                      </strong>
                      <div class="col95" style="max-height: 20vh;min-height:20vh;overflow-y:auto;">
                        <div v-for="(medicamento,mI) in listaMedicamentos" :key="medicamento" style="margin-left:20px;">
                          <button class="btnDefault" @click="deleteMedicamento(medicamento.c1)">
                            <i class="bi  bi-x" style="font-size: 1rem;"></i>
                          </button>
                          {{mI+1}} | {{medicamento.c0}} - {{medicamento.c1}}
                        </div>
                      </div>
                    </div>
                    <div v-else  style="min-height:20vh;">
                      <span>                        
                      </span>
                    </div>
                    <!--
                      <div style="margin-top:30px;">
                        <button class="btnBlue fullWidth center">
                          <i class="bi bi-pencil-square"></i>
                          Registrar Información de Medicamentos
                        </button>
                      </div>
                      -->

                  </div>
                  
              </div>

              <div class="fullWidth" v-if="modo=='DISCAPACIDAD'">                
                    
                  <strong class="formLabel " >        
                    Discapacidad:
                  </strong>
                  

                  <div class="tLeft fullWidth">

                    <div>
                      <div class="col50 row colSmMin95">
                        ¿Padece de alguna discapacidad?
                      </div>

                      <div class="col50 row colSmMin100">
                        <button class="btnDefault col50 row" @click="showNuevaDiscapacidad=true;">
                          Si
                        </button>
                        <button class="btnDefault col50 row" @click="showNuevaDiscapacidad=false;">
                          No
                        </button>
                      </div>
                    </div>
                    
                    <div v-if="showNuevaDiscapacidad">
                      <input-select-list
                      class="col75 row" 
                      :allowNew="true" 
                      :maxLength="85"
                      :minLength="4"
                      :capital="true"
                      :mode="'AN'"
                      :optionName="'Tipo de Discapacidad'"
                      :optionsArray="listaCatalogoDiscapacidades"
                      :displayFieldname="'c0'"
                      :valFieldName="'c0'"
                      :ref="'discapacidadRef'"
                      :placeholder="'Nombre de la Discapacidad'" 
                      :propName="'discapacidad'"
                      :whiteBackground="false" 
                      ></input-select-list>
                      <button class="btnBlue col25 row" @click="addNewDiscapacidad">
                        <i class="bi bi-plus col15 row left" style="font-size: 1.5rem;"></i>
                        <small class="col80 row">
                          Agregar
                        </small>
                      </button>

                    </div>
                    <div v-if="listaDiscapacidades.length>0">
                      <strong>
                        Discapacidades (Total: {{listaDiscapacidades.length}}):
                      </strong>

                      <div class="col95" style="max-height: 20vh;min-height:20vh;overflow-y:auto;">
                        <div v-for="(discapacidad,dI) in listaDiscapacidades" :key="discapacidad" style="margin-left:20px;">
                          <button class="btnDefault" @click="deleteDiscapacidad(dI)">
                            <i class="bi  bi-x" style="font-size: 1rem;"></i>
                          </button>
                          {{dI+1}} | {{discapacidad}}
                        </div>
                      </div>
                    </div>
                    <div v-else  style="min-height:20vh;">
                      <span>                        
                      </span>
                    </div>
                    <!--
                      <div style="margin-top:30px;">
                        <button class="btnBlue fullWidth center">
                          <i class="bi bi-pencil-square"></i>
                          Registrar Información de Discapacidad
                        </button>
                      </div>
                    -->

                  </div>
                  
                                
                
              </div>

              <div class="fullWidth " v-if="modo=='ANTECEDENTES'">

                  <strong class="formLabel " >
                    Antecedentes Quirurgico:
                  </strong>
                  <span style="min-width:5%;width:5%;"></span>

                  <div class="tLeft fullWidth">

                    <div>
                      <div class="col50 row colSmMin95">
                        ¿Tiene algún antecedente quirurgico?
                      </div>

                      <div class="col50 row colSmMin100">
                        <button class="btnDefault col50 row" @click="showNuevoAntecedente=true;">
                          Si
                        </button>
                        <button class="btnDefault col50 row" @click="showNuevoAntecedente=false;">
                          No
                        </button>
                      </div>
                    </div>

                    <div v-if="showNuevoAntecedente">
                      <input-text class="col75 row" ref="antecedenteRef" :placeholder="'Antecedente Quirurgico'" :propName="'antecedenteQuirurgico'" :whiteBackground="false" :mode="'AN'" 
                      :capital="true" :maxLength="120" :minLength="5"></input-text>
                      <button class="btnBlue col25 row" @click="addNewAntecedenteQuirurgico">
                        <i class="bi bi-plus col15 row left" style="font-size: 1.5rem;"></i>
                        <small class="col80 row">
                          Agregar
                        </small>
                      </button>

                    </div>
                    <div v-if="listaAntecedentesQuirurgicos.length>0">
                      <strong>
                        Antecedentes Quirurgicos (Total: {{listaAntecedentesQuirurgicos.length}}):
                      </strong>
                      <div class="col95" style="max-height: 20vh;min-height:20vh;overflow-y:auto;">
                        <div v-for="(antecedente,aI) in listaAntecedentesQuirurgicos" :key="antecedente">
                          <button class="btnDefault" @click="deleteAntecedente(aI)">
                            <i class="bi  bi-x" style="font-size: 1rem;"></i>
                          </button>
                          {{aI+1}} | {{antecedente}}
                        </div>
                      </div>
                    </div>
                    <div v-else  style="min-height:20vh;">
                      <span>                        
                      </span>
                    </div>
                    <!--
                      <div style="margin-top:30px;">
                        <button class="btnBlue fullWidth center">
                          <i class="bi bi-pencil-square"></i>
                          Registrar Información de Antecedentes Quirurgicos
                        </button>
                      </div>
                      -->

                  </div>

              </div>

              <div class="formCol col48 colSm95">
                <div class="formRow colSm95">
                  <span></span>                            
                </div>
              </div>

            </section>

          </div>
    
      </div>

    </div>
    
  </div>

  <modal title="Registro Antecedentes" v-if="showModal" v-on:closeModalEv="closeModal()" style="display:block;left:2.5vw;top:5vh;height:30vh;width:95vw;">
    <div style="text-align:center;overflow-y:auto;">
      <h3 style="color:black;">
        {{modalMessage}}
      </h3>
    </div>
    <div>
      <button class="btnBlue" @click="closeModal()">
        Aceptar y Continuar
      </button>
    </div>
  </modal>


</template>

<script>

import { mapStores } from 'pinia';
import { useUserStore } from '../../../store/user';
import InputText from '../../Inputs/InputText.vue';
//import InputPassword from '../Inputs/InputPassword.vue';

import Modal from '../../Modal/Modal.vue';
import InputSelectList from '../../Inputs/InputSelectList.vue';


export default {
  name: 'RegistroDatos',
  components:{
    Modal,
    InputText,    
    InputSelectList,
    //InputPassword
  },
  mounted:function(){
    console.log("RegistroDatos mounted");

    this.getListaEnfermedadesCronicasAlumno();
    this.getListaAlergiasAlumno();
    this.getListaMedicamentosAlumno();


    this.getListaCatalogoEnfermedadesCronicas();
    this.getListaCatalogoMedicamentos();
    this.getListaCatalogoAlergias();
    this.getListaCatalogoDiscapacidades();

  },
  data:function(){
    return{

      modo:'ENFERMEDAD',
      showNuevoMedicamento:false,
      showNuevaDiscapacidad:false,
      showNuevaAlergia:false,
      showNuevaEnfermedad:false,
      showNuevoAntecedente:false,
      showNuevoRegistro:false,
      registroExitoso:false,
      
      showModal:false,
      modalMessage:'',
      procesando:0,
      informacionEnviada:false,

      listaCatalogoEnfermedades:[],
      listaCatalogoAlergias:[],
      listaCatalogoMedicamentos:[],
      listaCatalogoDiscapacidades:[],

      listaEnfermedades:[],
      listaAlergias:[],
      listaMedicamentos:[],
      listaDiscapacidades:[],
      listaAntecedentesQuirurgicos:[],

      formData:{
        'enfermedad':{data:"",state:0,key:0},
        'alergia':{data:"",state:0},
        'medicamento':{data:"",state:0},
        'discapacidad':{data:"",state:0},
        'antecedenteQuirurgico':{data:"",state:0},
      },
    };    
  },
  methods:{

    /*Enfermedades INICIO*/
    addNewEnfermedadCronica(){
      let encontrado = false;
      let l = this.listaEnfermedades.length;
      for(let i=0;i<l;i++){
        if(this.listaEnfermedades[i].c0==this.formData.enfermedad.data){
          encontrado = true;
        }
      }
      if(!encontrado){
        this.sendRegistrarInformacionEnfermedades();
      }
    },

    sendRegistrarInformacionEnfermedades(){
      console.log("sendRegistrarInformacionEnfermedades()");

      let data = {
        id:''+this.userStore.idAlCur,
        enf:''+this.formData.enfermedad.data,        
      };
      console.log("data: ");
      console.log(data);
      
      if(!this.informacionEnviada){
        this.informacionEnviada = true;
        this.$root.sendPOSTRequest(
          "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/nuevoRegistroEnfermedadesCronicas/",
          data,
          this.onSuccessSendRegistrarInformacionEnfermedades
        );
      }else{
        this.showModal = true;
        this.modalMessage = "Su información esta siendo procesada, espere por favor."
      }

    },
    onSuccessSendRegistrarInformacionEnfermedades(data){

      console.log("onSuccessSendRegistrarInformacionEnfermedades:");
      console.log(data);

      this.listaEnfermedades[this.listaEnfermedades.length] = {c0:''+this.formData.enfermedad.data,c1:''+data.key};
      this.formData.enfermedad.data = "";
      this.formData.enfermedad.key++;
      this.informacionEnviada = false;
    },

    deleteEnfermedadCronica(key){
      this.sendDelInformacionEnfermedades(key);
    },

    sendDelInformacionEnfermedades(key){
      console.log("sendDelInformacionEnfermedades()");
      
      //let listaEnfermedades = JSON.stringify(this.listaEnfermedades);

      let data = {
        id:''+this.userStore.idAlCur,
        key:''+key,
        //listaEnf:''+listaEnfermedades
      };
      console.log("data: ");
      console.log(data);

      if(!this.informacionEnviada){
        this.informacionEnviada=true;
        this.$root.sendPOSTRequest(
          "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/deleteAlumnoEnfermedadCronica/",
          data,
          this.onSuccessDelInformacionEnfermedades
        );
      }else{
        this.showModal = true;
        this.modalMessage = "Su información esta siendo procesada, espere por favor."
      }

    },
    onSuccessDelInformacionEnfermedades(data){

      console.log("onSuccessDelInformacionEnfermedades:");
      console.log(data);

      console.log("key:"+data.key);

      let key = data.key;
      let l = this.listaEnfermedades.length;

      let i=0;
      let encontrado = false;
      while(i<l&&!encontrado){
        
        console.log("Objeto en del:");
        console.log(this.listaEnfermedades[i]);

        if(this.listaEnfermedades[i].c1===''+key){
          this.listaEnfermedades.splice(i,1);
          encontrado = true;
        }
        i++;
      }
      this.informacionEnviada = false;
      console.log("seguro liberado");

    },
    
    sendUpdateEstadoEnfermedad(val){
      console.log("getListaEnfermedadesCronicasAlumno()");

      let data = {
        idAl:''+this.userStore.idAlCur,
        val:''+val
      };
      console.log("data: ");
      console.log(data);
      
      if(!this.informacionEnviada){
        this.informacionEnviada = true;
        this.$root.sendPOSTRequest(
          "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/updateAlumnoEnfermedadesRegistradas/",
          data,
          this.onSuccessUpdateEstadoEnfermedad
        );
      }else{
        this.showModal = true;
        this.modalMessage = "Su información esta siendo procesada, espere por favor."
      }
    },
    onSuccessUpdateEstadoEnfermedad(data){
      console.log("onSuccessUpdateEstadoEnfermedad:");
      console.log(data);
      this.informacionEnviada = false;
    },

    getListaEnfermedadesCronicasAlumno(){
      console.log("getListaEnfermedadesCronicasAlumno()");

      let data = {
        id:''+this.userStore.idAlCur        
      };
      console.log("data: ");
      console.log(data);
      this.$root.sendPOSTRequest(
        "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/getListaAlumnoEnfermedades/",
        data,
        this.onSuccessGetListaEnfermedadesCronicasAlumno
      );
    },
    onSuccessGetListaEnfermedadesCronicasAlumno(data){
      console.log("onSuccessGetListaEnfermedadesCronicasAlumno:");
      console.log(data);
      this.setListaEnfermedadesCronicasAlumno(data.data.data);
    },
    setListaEnfermedadesCronicasAlumno(data){
      
      this.listaEnfermedades = data;
    },
    getListaCatalogoEnfermedadesCronicas(){
      console.log("getListaCatalogoEnfermedadesCronicas()");

      let data = {        
      };

      console.log("data: ");
      console.log(data);
      this.$root.sendPOSTRequest(
        "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/getListaEnfermedadesCronicas/",
        data,
        this.onSuccessGetListaCatalogoEnfermedadesCronicas
      );

    },
    onSuccessGetListaCatalogoEnfermedadesCronicas(data){
      console.log("onSuccessGetListaCatalogoEnfermedadesCronicas:");
      console.log(data);
      this.setListaCatalogoEnfermedadesCronicas(data.data.data);
    },
    setListaCatalogoEnfermedadesCronicas(data){
      this.listaCatalogoEnfermedades = data;
    },
  /*Enfermedades FIN*/

    

    /*ALERGIAS INICIO*/

    addNewAlergia(){
      let encontrado = false;
      let l = this.listaAlergias.length;
      for(let i=0;i<l;i++){
        if(this.listaAlergias[i].c0==this.formData.alergia.data){
          encontrado = true;
        }
      }
      if(!encontrado){
        this.sendRegistrarInformacionAlergias();
      }
    },

    sendRegistrarInformacionAlergias(){
      console.log("sendRegistrarInformacionAlergias()");

      let data = {
        id:''+this.userStore.idAlCur,
        aler:''+this.formData.alergia.data,        
      };
      
      if(!this.informacionEnviada){
        this.informacionEnviada = true;
        this.$root.sendPOSTRequest(
          "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/nuevoRegistroAlergias/",
          data,
          this.onSuccessSendRegistrarInformacionAlergias
        );
      }else{
        this.showModal = true;
        this.modalMessage = "Su información esta siendo procesada, espere por favor."
      }

    },
    onSuccessSendRegistrarInformacionAlergias(data){
      console.log("onSuccessSendRegistrarInformacionAlergias:");
      console.log(data);
      this.listaAlergias[this.listaAlergias.length] = {c0:''+this.formData.alergia.data,c1:''+data.key};
      this.formData.alergia.data = "";
      this.formData.alergia.key++;
      this.informacionEnviada = false;
      this.getListaAlergiasAlumno();
    },

    deleteAlergia(key){
      this.sendDelInformacionAlergias(key);
    },

    sendDelInformacionAlergias(key){
      console.log("sendDelInformacionAlergias()");
      
      let data = {
        id:''+this.userStore.idAlCur,
        key:''+key,
      };
      console.log("data: ");
      console.log(data);

      if(!this.informacionEnviada){
        this.informacionEnviada=true;
        this.$root.sendPOSTRequest(
          "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/deleteAlumnoAlergia/",
          data,
          this.onSuccessDelInformacionAlergias
        );
      }else{
        this.showModal = true;
        this.modalMessage = "Su información esta siendo procesada, espere por favor."
      }

    },
    onSuccessDelInformacionAlergias(data){

      console.log("onSuccessDelInformacionAlergias:");
      console.log(data);
      console.log("key:"+data.key);
      let key = data.key;
      let l = this.listaAlergias.length;
      let i=0;
      let encontrado = false;
      while(i<l&&!encontrado){
        
        console.log("Objeto en del:");
        console.log(this.listaAlergias[i]);

        if(this.listaAlergias[i].c1===''+key){
          this.listaAlergias.splice(i,1);
          encontrado = true;
        }
        i++;
      }
      this.informacionEnviada = false;
      console.log("seguro liberado");
    },

    sendUpdateEstadoAlergia(val){
      console.log("sendUpdateEstadoAlergia()");

      let data = {
        idAl:''+this.userStore.idAlCur,
        val:''+val
      };
      console.log("data: ");
      console.log(data);
      
      if(!this.informacionEnviada){
        this.informacionEnviada = true;
        this.$root.sendPOSTRequest(
          "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/updateAlumnoAlergiasRegistradas/",
          data,
          this.onSuccessUpdateEstadoAlergia
        );
      }else{
        this.showModal = true;
        this.modalMessage = "Su información esta siendo procesada, espere por favor."
      }
    },
    onSuccessUpdateEstadoAlergia(data){
      console.log("onSuccessUpdateEstadoAlergia:");
      console.log(data);
      this.informacionEnviada = false;
    },

    getListaAlergiasAlumno(){
      console.log("getListaAlergiasAlumno()");

      let data = {
        id:''+this.userStore.idAlCur        
      };
      console.log("data: ");
      console.log(data);
      this.$root.sendPOSTRequest(
        "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/getListaAlumnoAlergias/",
        data,
        this.onSuccessGetListaAlergiasAlumno
      );
    },
    onSuccessGetListaAlergiasAlumno(data){
      console.log("onSuccessGetListaAlergiasAlumno:");
      console.log(data);
      this.setListaAlergiasAlumno(data.data.data);
    },
    setListaAlergiasAlumno(data){      
      this.listaAlergias = data;
    },

    getListaCatalogoAlergias(){
      console.log("getListaCatalogoAlergias()");
      let data = {        
      };
      console.log("data: ");
      console.log(data);
      this.$root.sendPOSTRequest(
        "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/getListaAlergias/",
        data,
        this.onSuccessGetListaCatalogoAlergias
      );

    },
    onSuccessGetListaCatalogoAlergias(data){
      console.log("onSuccessGetListaCatalogoAlergias:");
      console.log(data);
      this.setListaCatalogoAlergias(data.data.data);

    },
    setListaCatalogoAlergias(data){
      this.listaCatalogoAlergias = data;
    },

    /*FIN ALERGIAS*/


    /*MEDICAMENTOS INICIO*/
    
    addNewMedicamento(){
      let encontrado = false;
      let l = this.listaMedicamentos.length;
      for(let i=0;i<l;i++){
        if(this.listaMedicamentos[i].c0==this.formData.medicamento.data){
          encontrado = true;
        }
      }
      if(!encontrado){
        this.sendRegistrarInformacionMedicamentos();
      }
    },

    sendRegistrarInformacionMedicamentos(){
      console.log("sendRegistrarInformacionMedicamentos()");
      let data = {
        id:''+this.userStore.idAlCur,
        med:''+this.formData.medicamento.data,        
      };
      
      if(!this.informacionEnviada){
        this.informacionEnviada = true;
        this.$root.sendPOSTRequest(
          "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/nuevoRegistroMedicamentos/",
          data,
          this.onSuccessSendRegistrarInformacionMedicamentos
        );
      }else{
        this.showModal = true;
        this.modalMessage = "Su información esta siendo procesada, espere por favor."
      }
    },
    onSuccessSendRegistrarInformacionMedicamentos(data){

      console.log("onSuccessSendRegistrarInformacionMedicamentos:");
      console.log(data);

      this.listaMedicamentos[this.listaMedicamentos.length] = {c0:''+this.formData.medicamento.data,c1:''+data.key};
      this.formData.medicamento.data = "";
      this.formData.medicamento.key++;
      this.informacionEnviada = false;
    },
    
    deleteMedicamento(key){
      this.sendDelInformacionMedicamentos(key);
    },

    sendDelInformacionMedicamentos(key){
      console.log("sendDelInformacionMedicamentos()");
      
      let data = {
        id:''+this.userStore.idAlCur,
        key:''+key,
      };

      if(!this.informacionEnviada){
        this.informacionEnviada=true;
        this.$root.sendPOSTRequest(
          "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/deleteAlumnoMedicamentos/",
          data,
          this.onSuccessDelInformacionMedicamentos
        );
      }else{
        this.showModal = true;
        this.modalMessage = "Su información esta siendo procesada, espere por favor."
      }

    },
    onSuccessDelInformacionMedicamentos(data){

      console.log("onSuccessDelInformacionMedicamentos:");
      console.log(data);
      console.log("key:"+data.key);

      let key = data.key;
      let l = this.listaMedicamentos.length;

      let i=0;
      let encontrado = false;
      while(i<l&&!encontrado){
        console.log("Objeto en del:");
        console.log(this.listaMedicamentos[i]);

        if(this.listaMedicamentos[i].c1===''+key){
          this.listaMedicamentos.splice(i,1);
          encontrado = true;
        }
        i++;
      }
      this.informacionEnviada = false;
      console.log("seguro liberado");
    },

    sendUpdateEstadoMedicamento(val){
      console.log("sendUpdateEstadoMedicamento()");

      let data = {
        idAl:''+this.userStore.idAlCur,
        val:''+val
      };
      console.log("data: ");
      console.log(data);
      
      if(!this.informacionEnviada){
        this.informacionEnviada = true;
        this.$root.sendPOSTRequest(
          "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/updateAlumnoMedicamentosRegistrados/",
          data,
          this.onSuccessUpdateEstadoMedicamento
        );
      }else{
        this.showModal = true;
        this.modalMessage = "Su información esta siendo procesada, espere por favor."
      }
    },
    onSuccessUpdateEstadoMedicamento(data){
      console.log("onSuccessUpdateEstadoMedicamento:");
      console.log(data);
      this.informacionEnviada = false;
    },

    getListaMedicamentosAlumno(){
      console.log("getListaMedicamentosAlumno()");

      let data = {
        id:''+this.userStore.idAlCur
      };
      console.log("data: ");
      console.log(data);
      this.$root.sendPOSTRequest(
        "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/getListaAlumnoMedicamentos/",
        data,
        this.onSuccessGetListaMedicamentosAlumno
      );
    },
    onSuccessGetListaMedicamentosAlumno(data){
      console.log("onSuccessGetListaMedicamentosAlumno:<---");
      console.log(data.data);
      this.setListaMedicamentosAlumno(data.data.data);
    },
    setListaMedicamentosAlumno(data){
      this.listaMedicamentos = data;
    },

    getListaCatalogoMedicamentos(){
      console.log("getListaCatalogoMedicamentos()");
      let data = {        
      };

      console.log("data: ");
      console.log(data);
      this.$root.sendPOSTRequest(
        "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/getListaMedicamentos/",
        data,
        this.onSuccessGetListaCatalogoMedicamentos
      );

    },
    onSuccessGetListaCatalogoMedicamentos(data){
      console.log("onSuccessGetListaCatalogoMedicamentos:");
      console.log(data);
      this.setListaCatalogoMedicamentos(data.data.data);

    },
    setListaCatalogoMedicamentos(data){
      this.listaCatalogoMedicamentos = data;
    },

    /*MEDICAMENTOS FIN*/

    /*DISCAPACIDAD INICIO*/

    addNewDiscapacidad(){
      let encontrado = false;
      let l = this.listaDiscapacidades.length;
      for(let i=0;i<l;i++){
        if(this.listaDiscapacidades[i].c0==this.formData.discapacidad.data){
          encontrado = true;
        }
      }
      if(!encontrado){
        this.sendRegistrarInformacionDiscapacidad();
      }
    },

    sendRegistrarInformacionDiscapacidad(){
      console.log("sendRegistrarInformacionDiscapacidad()");

      let data = {
        id:''+this.userStore.idAlCur,
        enf:''+this.formData.discapacidad.data,        
      };
      console.log("data: ");
      console.log(data);
      
      if(!this.informacionEnviada){
        this.informacionEnviada = true;
        this.$root.sendPOSTRequest(
          "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/nuevoRegistroDiscapacidades/",
          data,
          this.onSuccessSendRegistrarInformacionDiscapacidades
        );
      }else{
        this.showModal = true;
        this.modalMessage = "Su información esta siendo procesada, espere por favor."
      }

    },
    onSuccessSendRegistrarInformacionDiscapacidades(data){

      console.log("onSuccessSendRegistrarInformacionEnfermedades:");
      console.log(data);

      this.listaDiscapacidades[this.listaDiscapacidades.length] = {c0:''+this.formData.discapacidad.data,c1:''+data.key};
      this.formData.discapacidad.data = "";
      this.formData.discapacidad.key++;
      this.informacionEnviada = false;
    },

    deleteDiscapacidad(key){
      this.sendDelInformacionDiscapacidades(key);
    },

    sendDelInformacionDiscapacidades(key){
      console.log("sendDelInformacionDiscapacidades()");
      
      let data = {
        id:''+this.userStore.idAlCur,
        key:''+key,
        //listaEnf:''+listaEnfermedades
      };
      console.log("data: ");
      console.log(data);

      if(!this.informacionEnviada){
        this.informacionEnviada=true;
        this.$root.sendPOSTRequest(
          "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/deleteAlumnoDiscapacidades/",
          data,
          this.onSuccessDelInformacionDiscapacidades
        );
      }else{
        this.showModal = true;
        this.modalMessage = "Su información esta siendo procesada, espere por favor."
      }

    },
    onSuccessDelInformacionDiscapacidades(data){

      console.log("onSuccessDelInformacionDiscapacidades:");
      console.log(data);
      let key = data.key;
      let l = this.listaDiscapacidades.length;

      let i=0;
      let encontrado = false;

      while(i<l&&!encontrado){
        console.log("Objeto en del:");
        console.log(this.listaDiscapacidades[i]);
        if(this.listaDiscapacidades[i].c1===''+key){
          this.listaDiscapacidades.splice(i,1);
          encontrado = true;
        }
        i++;
      }
      this.informacionEnviada = false;
      console.log("seguro liberado");
    },
    
    sendUpdateEstadoDiscpacidad(val){
      console.log("sendUpdateEstadoDiscpacidad()");

      let data = {
        idAl:''+this.userStore.idAlCur,
        val:''+val
      };
      console.log("data: ");
      console.log(data);
      
      if(!this.informacionEnviada){
        this.informacionEnviada = true;
        this.$root.sendPOSTRequest(
          "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/updateAlumnoDiscapacidadesRegistradas/",
          data,
          this.onSuccessUpdateEstadoDiscapacidad
        );
      }else{
        this.showModal = true;
        this.modalMessage = "Su información esta siendo procesada, espere por favor."
      }
    },
    onSuccessUpdateEstadoDiscapacidad(data){
      console.log("onSuccessUpdateEstadoEnfermedad:");
      console.log(data);
      this.informacionEnviada = false;
    },

    getListaDiscapacidadesAlumno(){
      console.log("getListaDiscapacidadesAlumno()");

      let data = {
        id:''+this.userStore.idAlCur        
      };
      console.log("data: ");
      console.log(data);
      this.$root.sendPOSTRequest(
        "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/getListaAlumnoDiscapacidades/",
        data,
        this.onSuccessGetListaDiscapacidadesAlumno
      );
    },
    onSuccessGetListaDiscapacidadesAlumno(data){
      console.log("onSuccessGetListaDiscapacidadesAlumno:");
      console.log(data);
      this.setListaDiscapacidadesAlumno(data.data.data);
    },
    setListaDiscapacidadesAlumno(data){
      this.listaDiscapacidades = data;
    },
    getListaCatalogoDiscapacidades(){
      console.log("getListaCatalogoDiscapacidades()");
      let data = {        
      };
      console.log("data: ");
      console.log(data);
      this.$root.sendPOSTRequest(
        "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/getListaDiscapacidades/",
        data,
        this.onSuccessGetListaCatalogoDiscapacidades
      );
    },
    onSuccessGetListaCatalogoDiscapacidades(data){
      console.log("onSuccessGetListaCatalogoDiscapacidades:");
      console.log(data);
      this.setListaCatalogoEnfermedadesCronicas(data.data.data);

    },
    setListaCatalogoDiscapacidades(data){
      this.listaCatalogoDiscapacidades = data;
    },
    /*DISCAPACIDAD FIN*/


    /*ANTECEDENTES INICIO*/
    addNewAntecedenteQuirurgico(){
      let encontrado = false;
      let l = this.listaAntecedentesQuirurgicos.length;
      for(let i=0;i<l;i++){
        if(this.listaAntecedentesQuirurgicos[i].c0==this.formData.antecedenteQuirurgico.data){
          encontrado = true;
        }
      }
      if(!encontrado){
        this.sendRegistrarInformacionAntecedenteQuirurgico();
      }
    },

    sendRegistrarInformacionAntecedenteQuirurgico(){
      console.log("sendRegistrarInformacionAntecedenteQuirurgico()");

      let data = {
        id:''+this.userStore.idAlCur,
        enf:''+this.formData.antecedenteQuirurgico.data,        
      };
      console.log("data: ");
      console.log(data);
      
      if(!this.informacionEnviada){
        this.informacionEnviada = true;
        this.$root.sendPOSTRequest(
          "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/nuevoRegistroAntecedenteQuirurgico/",
          data,
          this.onSuccessSendRegistrarInformacionAntecedentesQuirurgicos
        );
      }else{
        this.showModal = true;
        this.modalMessage = "Su información esta siendo procesada, espere por favor."
      }

    },
    onSuccessSendRegistrarInformacionAntecedentesQuirurgicos(data){

      console.log("onSuccessSendRegistrarInformacionAntecedentesQuirurgicos:");
      console.log(data);

      this.listaEnfermedades[this.listaEnfermedades.length] = {c0:''+this.formData.enfermedad.data,c1:''+data.key};
      this.formData.enfermedad.data = "";
      this.formData.enfermedad.key++;
      this.informacionEnviada = false;
    },

    deleteAntecedenteQuirurgico(key){
      this.sendDelAntecedentesQuirurgicos(key);
    },

    sendDelAntecedentesQuirurgicos(key){
      console.log("sendDelInformacionEnfermedades()");
      
      //let listaEnfermedades = JSON.stringify(this.listaEnfermedades);

      let data = {
        id:''+this.userStore.idAlCur,
        key:''+key,
        //listaEnf:''+listaEnfermedades
      };
      console.log("data: ");
      console.log(data);

      if(!this.informacionEnviada){
        this.informacionEnviada=true;
        this.$root.sendPOSTRequest(
          "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/deleteAlumnoEnfermedadCronica/",
          data,
          this.onSuccessDelInformacionEnfermedades
        );
      }else{
        this.showModal = true;
        this.modalMessage = "Su información esta siendo procesada, espere por favor."
      }

    },
    onSuccessDelAntecedentesQuirurgicos(data){

      console.log("onSuccessDelInformacionEnfermedades:");
      console.log(data);

      console.log("key:"+data.key);

      let key = data.key;
      let l = this.listaEnfermedades.length;

      let i=0;
      let encontrado = false;
      while(i<l&&!encontrado){
        
        console.log("Objeto en del:");
        console.log(this.listaEnfermedades[i]);

        if(this.listaEnfermedades[i].c1===''+key){
          this.listaEnfermedades.splice(i,1);
          encontrado = true;
        }
        i++;
      }
      this.informacionEnviada = false;
      console.log("seguro liberado");

    },
    
    sendUpdateAntecedentesQuirurgicos(val){
      console.log("getListaEnfermedadesCronicasAlumno()");

      let data = {
        idAl:''+this.userStore.idAlCur,
        val:''+val
      };
      console.log("data: ");
      console.log(data);
      
      if(!this.informacionEnviada){
        this.informacionEnviada = true;
        this.$root.sendPOSTRequest(
          "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/updateAlumnoEnfermedadesRegistradas/",
          data,
          this.onSuccessUpdateEstadoEnfermedad
        );
      }else{
        this.showModal = true;
        this.modalMessage = "Su información esta siendo procesada, espere por favor."
      }
    },
    onSuccessUpdateAntecedentesQuirurgicos(data){
      console.log("onSuccessUpdateEstadoEnfermedad:");
      console.log(data);
      this.informacionEnviada = false;
    },

    getListaAntecedentesQuirurgicosAlumno(){
      console.log("getListaEnfermedadesCronicasAlumno()");

      let data = {
        id:''+this.userStore.idAlCur        
      };
      console.log("data: ");
      console.log(data);
      this.$root.sendPOSTRequest(
        "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/getListaAlumnoEnfermedades/",
        data,
        this.onSuccessGetListaEnfermedadesCronicasAlumno
      );
    },
    onSuccessGetListaAntecedenteQuirurgicoAlumno(data){
      console.log("onSuccessGetListaEnfermedadesCronicasAlumno:");
      console.log(data);
      this.setListaEnfermedadesCronicasAlumno(data.data.data);
    },
    setListaAntecedenteQuirurgicoAlumno(data){
      
      this.listaEnfermedades = data;
    },
    getListaCatalogoAntecedentesQuirurgicos(){
      console.log("getListaCatalogoEnfermedadesCronicas()");

      let data = {        
      };

      console.log("data: ");
      console.log(data);
      this.$root.sendPOSTRequest(
        "https://www.sitioliceo.com/scLCcur/api/superSC/v1/alumnos/getListaEnfermedadesCronicas/",
        data,
        this.onSuccessGetListaCatalogoEnfermedadesCronicas
      );

    },
    onSuccessGetListaCatalogoAntecedentesQuirurgicos(data){
      console.log("onSuccessGetListaCatalogoEnfermedadesCronicas:");
      console.log(data);
      this.setListaCatalogoEnfermedadesCronicas(data.data.data);

    },
    setListaCatalogoAntecedentesQuirurgicos(data){
      this.listaCatalogoEnfermedades = data;
    },

    /*ANTECEDENTES FIN*/

    
    sendClose(){

      this.$emit('closeAccionEv');

    },

    isRegistroCompleted(){

      return (
      this.formData.enfermedad.state==1&&
      this.formData.alergia.state==1&&
      this.formData.medicamento.state==1&&
      this.formData.antecedenteQuirurgico.state==1
      );

    },

    closeAccion(){

      this.$emit('closeAccionEv');

    },

    closeModal(){
      this.showModal = false;      
    },


        

    

  },
  computed:{
    ...mapStores(useUserStore),
    
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.glassModulo{
    
    z-index:100;  
    
    background: rgba(255,255,255,0.30);    
    backdrop-filter: blur(2px);
    box-shadow: 0 10px 32px 0 rgba(31,38,135,0.37);    
    margin: 0 auto;
    margin-bottom: 0px;
    border-radius: 10px;
    padding:5px;
    border: 1px solid rgba(255,255,255,0.18);
    
  }

</style>
